import { useEffect } from 'react';

type MetaTagKey = { name: string } | { property: string };

type PageMeta = {
  title: string;
  description?: string;
};

function ensureMetaTag(key: MetaTagKey): HTMLMetaElement {
  const selector = 'name' in key ? `meta[name="${key.name}"]` : `meta[property="${key.property}"]`;
  let el = document.head.querySelector(selector) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    if ('name' in key) el.setAttribute('name', key.name);
    if ('property' in key) el.setAttribute('property', key.property);
    document.head.appendChild(el);
  }
  return el;
}

export function usePageMeta({ title, description }: PageMeta) {
  useEffect(() => {
    document.title = title;

    if (description !== undefined) {
      ensureMetaTag({ name: 'description' }).setAttribute('content', description);
      ensureMetaTag({ property: 'og:description' }).setAttribute('content', description);
      ensureMetaTag({ name: 'twitter:description' }).setAttribute('content', description);
    }

    ensureMetaTag({ property: 'og:title' }).setAttribute('content', title);
    ensureMetaTag({ name: 'twitter:title' }).setAttribute('content', title);
    ensureMetaTag({ property: 'og:type' }).setAttribute('content', 'website');
    ensureMetaTag({ property: 'og:site_name' }).setAttribute('content', 'HCAE Client Portal');
    ensureMetaTag({ name: 'twitter:card' }).setAttribute('content', 'summary');

    if (typeof window !== 'undefined') {
      ensureMetaTag({ property: 'og:url' }).setAttribute('content', window.location.href);
    }
  }, [title, description]);
}
